(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Campagna_type', Campagna_type);

    Campagna_type.$inject = ['$resource'];

    function Campagna_type ($resource) {
        var resourceUrl =  'api/campagna-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
